import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService, FormService } from 'src/app/services';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss', '../common.scss'],
})
export class LoginComponent implements OnInit {
	public isLoading = false;
	public loginForm = new FormGroup({
		email: new FormControl('', [Validators.required, Validators.email]),
		password: new FormControl('', Validators.required),
	});

	loginFormErrorMessages = {
		email: [
			{ type: 'required', message: 'Email is required' },
			{ type: 'email', message: 'Enter a valid email' },
		],
		password: [{ type: 'required', message: 'Password is required' }],
	};

	constructor(
		public authService: AuthService,
		public formService: FormService,
		private route: ActivatedRoute,
	) {
		this.authService.earthTokenExists();
	}

	public ngOnInit(): void {
		// comment
		this.route.queryParams.subscribe((params: any) => {
			if (params.token) {
				this.authService.loginWithCustomToken(params.token, true);
			} else if (params.error) {
				this.authService.addToastMsg(params.error);
			}
		});
	}

	public onSubmit(loginForm: any) {
		if (!this.isLoading) {
			this.isLoading = true;

			this.formService.markFormGroupTouched(loginForm);

			if (loginForm.status !== 'VALID') {
				this.isLoading = false;
				this.authService.addToastMsg('Please fill missing detail.');
				return;
			}

			this.authService
				.signIn(loginForm.value.email, loginForm.value.password)
				.catch(e => {
					this.isLoading = false;
				});
		}
	}

	public signupUsingGoogle() {
		this.authService.googleSignIn();
	}

	signupUsingLinkedin() {
		const parsedUrl = new URL(window.location.href);

		let url = parsedUrl.origin;

		let redirect_uri =
			'https://hubble-lookup-service-dot-hubble-prod-dcbd4.uc.r.appspot.com/';

		const sendRidirectUrl =
			'https://www.linkedin.com/oauth/v2/authorization' +
			'?response_type=code&' +
			'client_id=' +
			'77jefy2czp7y5b' +
			'&' +
			// "redirect_uri=" + 'http://localhost:3003/api/social-media/linkedIn-token/' + "&" +
			'redirect_uri=' +
			redirect_uri +
			'api/social-media/linkedIn-token/' +
			'&' +
			'state=' +
			url +
			'&' +
			'scope=' +
			'r_liteprofile%20r_emailaddress';
		window.location.href = sendRidirectUrl;
	}
}
